/**
 * The seed theme, as data — PRD 02 §8, PRD 01 §3–§4.
 *
 * Exactly one theme exists: `handcrafted-cutpaper`, the "Handcrafted Wonder" system. There
 * is no theme picker and no theme-management UI. The seam exists so a future theme is just
 * "generate primitives in theme X" with zero schema change; the matrix does not multiply
 * while there is one theme (×1).
 */
/** The Handcrafted Wonder palette (PRD 01 §3). Hex values are the contract with the design system. */
export const HANDCRAFTED_CUTPAPER_PALETTE = Object.freeze({
    background: '#F4EBDC',
    teal: '#3F6B6B',
    mustard: '#C9922E',
    spark: '#E4552B',
    ink: '#2E2A26',
});
/**
 * The style block the engine conditions on. Written plainly here; the image-worker prompt
 * refines it into the full adapter instruction.
 */
export const HANDCRAFTED_CUTPAPER_STYLE_DESCRIPTOR = 'Flat cut-paper collage illustration. Every element reads as a piece of torn or scissor-cut ' +
    'matte paper laid on a warm cream ground: hard clean edges, no outlines, no gradients, no ' +
    'gloss, and no 3D shading. Depth comes from overlapping paper shapes and soft drop shadows ' +
    'only. Shapes are simple, generous, and hand-cut rather than geometric. Colour is limited to ' +
    'the theme palette — warm cream background #F4EBDC, deep teal #3F6B6B, mustard #C9922E, ' +
    'a sparing warm orange accent #E4552B, and near-black ink #2E2A26 for the smallest details. ' +
    'Texture is the subtle grain of paper stock, never a photographic or painterly surface. ' +
    'Warm, calm, handmade, and childlike without being cute.';
export const HANDCRAFTED_CUTPAPER = {
    id: 'handcrafted-cutpaper',
    name: { en: 'Handcrafted Wonder' },
    styleDescriptor: HANDCRAFTED_CUTPAPER_STYLE_DESCRIPTOR,
    palette: { ...HANDCRAFTED_CUTPAPER_PALETTE },
    active: true,
};
/** The active theme id. One theme, deliberately (PRD 02 §8). */
export const DEFAULT_THEME_ID = HANDCRAFTED_CUTPAPER.id;
//# sourceMappingURL=theme.js.map